import { Outlet } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './AppNavbar';
import SideMenu from './SideMenu';
import GlobalSnackbar from './GlobalSnackbar';

export default function Layout() {
	return (
		<>
			<CssBaseline enableColorScheme />
			<Box sx={{ display: 'flex' }}>
				<SideMenu />
				<AppNavbar />
				{/* Main content */}
				<Box
					component="main"
					sx={(theme) => ({
						flexGrow: 1,
						minWidth: 0,
						backgroundColor: alpha(theme.palette.background.default, 1),
						overflow: 'auto',
						minHeight: '100vh',
						pt: { xs: 8, md: 2 },
					})}
				>
					<Stack
						spacing={2}
						sx={{
							alignItems: 'stretch',
							px: { xs: 2, md: 3 },
							pb: 3,
							mt: { xs: 2, md: 0 },
						}}
					>
						<Outlet />
					</Stack>
				</Box>
			</Box>
			<GlobalSnackbar />
		</>
	);
}